export default __webpack_public_path__ + "static/media/ic-quote.8850676e.svg";